<div class="error-wrapper">
    <div class="container">
        <img class="img-100" src="assets/images/other-images/sad.png" alt="No Access">
        <div class="error-heading">
            <h2 class="headline font-primary">403</h2>
        </div>
        <div class="col-md-8 offset-md-2">
            <h3 class="mb-3 font-secondary" style="font-size: 24px; font-weight: 600;">Access Denied</h3>
            <p class="sub-content">You do not have permission to access this page. Please contact your administrator if you believe this is an error.</p>
        </div>
        <div class="mt-4">
            <button type="button" class="btn btn-primary btn-lg" (click)="goBack()">GO BACK</button>
        </div>
    </div>
</div>
